const images = {
	"logo": require("./logo.png"),
	"pdf": require("./pdf.png"),
	"info": require("./info.png"),
};

export default images;
